import { render } from "./horizontal-timeline.vue?vue&type=template&id=a0510fb4"
import script from "./horizontal-timeline.vue?vue&type=script&lang=js"
export * from "./horizontal-timeline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__